exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-button{background-size:contain;color:#000;text-transform:uppercase;font-size:14pt;border-radius:0;padding:8px 16px;font-weight:700;width:100%;border-radius:8px;border:none;outline:none}.widget_form_box input,.widget_form_box textarea{color:#fff}.footer-input{border-radius:8px;font-style:italic;color:#f0ecc7!important;background:#3f2c28!important;resize:none}.contact{margin-top:20px;color:#f0ecc7;font-size:18px}.contact img{margin-right:10px;height:40px;margin-bottom:15px}.contact span{margin-bottom:15px;color:#f0ecc7!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66fc642f","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/bora/Footer.vue
// module id = 76
// module chunks = 0 1 2